import bannersApi from '../../api/banners-api';

const banners = {
  items: [],
  item: {},
  popupNewBanner: false,
  popupEditBanner: false,
  popupSeeBanner: false
};

const mutations = {
  setItemsBanners(state, payload) {
      state.items = payload.data;
  },
  setItemBanner(state, payload) {
      state.item = payload;
  },
  setpopupNewBanner(state, payload) {
      state.popupNewBanner = payload;
  },
  setpopupEditBanner(state, payload) {
      state.popupEditBanner = payload;
  },
  setpopupSeeBanner(state, payload) {
    state.popupSeeBanner = payload;
  }
};

const actions = {
  async refreshBanners({ commit }, restaurant_id) {
    commit('loading', true);
    const res = await bannersApi.getAllBanners(restaurant_id);
    commit('loading', false);
    commit('setItemsBanners', res);
  },

  async getBanner({ commit }, {id}) {
    commit('loading', true);
    commit('setItemBanner', {});
    bannersApi.getOne(id).then(
        (response) => {
          commit('setItemBanner', response.data);
          commit('loading', false);
        },
        (error) => {
          commit('loading', false);
          commit('notifications', { title: 'banner.GetErrorBanner', text: error.response.data.message, color: 'danger' });
          commit('showNotifications', true);
        }
    );
  },
  createBanner({ commit, dispatch }, { banner, restaurant_id }) {
    commit('loading', true);
    bannersApi.create(banner).then(
        () => {
            dispatch('refreshBanners', restaurant_id);
            commit('notifications', { title: 'banner.CreateSuccessBanner' });
            commit('setpopupNewBanner', false);
            commit('loading', false);
            commit('showNotifications', true);
            commit('setCreatedCorrect', true);
        },
        (error) => {
            commit('loading', false);
            commit('notifications', { title: 'banner.CreateErrorBanner', text: error.response.data.message, color: 'danger' });
            commit('showNotifications', true);
        },
      );
  },
  deleteBanner({ commit, dispatch }, {id, restaurant_id}) {
    commit('loading', true);
    bannersApi.delete(id).then(
        () => {
            dispatch('refreshBanners', restaurant_id);
            commit('notifications', { title: 'banner.RemoveSuccessBanner' });
            commit('loading', false);
            commit('showNotifications', true);
        },
        (error) => {
            commit('notifications', { title: 'banner.RemoveErrorBanner', text: error.response.data.message, color: 'danger' });
            commit('loading', false);
            commit('showNotifications', true);
        },
    );
  },
  activeBanner({ commit, dispatch }, { id, restaurant_id }) {
    commit('loading', true);
    bannersApi.active(id).then(
        () => {
            dispatch('refreshBanners', restaurant_id);
            commit('notifications', { title: 'banner.ActivateSuccessBanner' });
            commit('loading', false);
            commit('showNotifications', true);
        },
        (error) => {
            commit('notifications', { title: 'banner.ActivateErrorBanner', text: error.response.data.message, color: 'danger' });
            commit('loading', false);
            commit('showNotifications', true);
        },
    );
  },
  deactiveBanner({ commit, dispatch }, { id, restaurant_id }) {
    commit('loading', true);
    bannersApi.deactive(id).then(
      () => {
          dispatch('refreshBanners', restaurant_id);
          commit('notifications', { title: 'banner.DeactivateSuccessBanner' });
          commit('loading', false);
          commit('showNotifications', true);
      },
      (error) => {
          commit('notifications', { title: 'banner.DeactivateErrorBanner', text: error.response.data.message, color: 'danger' });
          commit('loading', false);
          commit('showNotifications', true);
      },
    );
  },
  editBanner({ commit, dispatch }, { id, banner, restaurant_id }) {
    commit('loading', true);
    bannersApi.edit(id, banner).then(
        () => {
          dispatch('refreshBanners', restaurant_id);
          commit('notifications', { title: 'banner.EditSuccessBanner' });
          commit('loading', false);
          commit('setpopupEditBanner', false);
          commit('showNotifications', true);
        },
        (error) => {
          commit('notifications', { title: 'banner.EditErrorBanner', text: error.response.data.message, color: 'danger' });
          commit('loading', false);
          commit('showNotifications', true);
        },
    );
  }
};

const getters = {
  getBanner: state => state.item,
  getItemsBanners: state => state.items,
  getpopupNewBanner: state => state.popupNewBanner,
  getpopupEditBanner: state => state.popupEditBanner,
  getpopupSeeBanner: state => state.popupSeeBanner
};

export default {
  state: banners,
  mutations,
  actions,
  getters
};
